import React from 'react';
import {  Routes, Route } from 'react-router-dom';
import Documentation from './Documentation';
import Home from './Home';

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/documentation" element={<Documentation />} />
    </Routes>
  );
};

export default App;
